export const icons = {
  check: 'assets/icons/check.apng',
  confetti: 'assets/icons/confetti.apng',
  cart_empty: 'assets/icons/cart_empty.apng',
  llayers: 'assets/icons/llayers.apng',
  spin: 'assets/icons/spin.apng',
};

export const infiniteLoopedIcons = ['spin', 'confetti'];
